import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class } from "./utils";
/**
 *
 * @class Result
 * @classdesc A single result from a searcher. May represent either a real result or a new query. Only Searchers will create instances of Result
 * 
 */

export default Class({
  /**
   This result's type
   @name Result#type
   @type String
   @readonly
   */
  type: null,

  /**
   This result's source
   @name Result#source
   @type String
   @readonly
   */
  source: null,

  /**
   This result's title
   @name Result#title
   @type String
   @readonly
   */
  title: null,

  /**
   This result's description
   @name Result#description
   @type String
   @readonly
   */
  description: null,

  /**
   This result's geometry (GeoJson geometry)
   @name Result#geometry
   @type Object
   @readonly
   */
  geometry: null,

  /**
   This result's data (As returned from underlying service or data)
   @name Result#data
   @type Object
   @readonly
   */
  data: null,

  /**
   This result's searcher
   @name Result#searcher
   @type Object
   @readonly
   */
  searcher: null,

  /**
   This result's image url
   @name Result#image
   @type String
   @readonly
   */
  image: null,

  /**
   This newquery suggestion
   @name Result#newquery
   @type String
   @readonly
   */
  newquery: null,

  /**
   This result's distance from other result
   @name Result#source
   @type float
   @readonly
   */
  distance: null,

  /**
   This result's route
   @name Result#route
   @type Object
   @readonly
   */
  route: null,
  isComplete: true,
  initialize: function initialize(options) {
    Object.assign(this, options);
  },
  isNewQuery: function isNewQuery() {
    return typeof this.newquery !== 'undefined' && this.newquery !== null;
  },
  complete: function () {
    var _complete = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this.isComplete || this.searcher === null)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", this);

            case 4:
              return _context.abrupt("return", this.searcher.completeResult(this));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function complete() {
      return _complete.apply(this, arguments);
    }

    return complete;
  }(),
  CLASS_NAME: 'Septima.Search.Result'
});